import { makeStyles } from '@material-ui/core'
import React, { ReactElement, useEffect, useState } from 'react'
import {  getQuestion, setActiveQuestion } from '../../api/chatApi/chatApi'
import ExpertQuestionModal from './ExpertQuestionModal'
import { IconButton, Badge } from '@material-ui/core'
import { Notifications } from '@material-ui/icons'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    width: 300,
    margin: (p: Props) =>
      p.margin ? theme.spacing(p.margin) : theme.spacing(2),
    background: theme.palette.background.paper,
    border: '2px dashed',
    borderRadius: 20,
    borderColor: theme.palette.divider,
    cursor: 'pointer',
    fontSize: 20,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    textAlign: 'center',
    '&:hover': {
      border: '2px solid',
      borderColor: theme.palette.primary.main
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
    position: 'relative'

  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
    alignContent: 'center'
  },
  bellIcon: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    zIndex: 1,
  },
  bellButton: {
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    }
  }
}))

interface Props {
  children?: string | React.ReactNode
  onClick?: any
  item?: any
  margin?: number
  taskId: number
  userId: number
}

interface ExpertQuestionData {
  questions: Array<{
    id: number;
    question: string;
    answer: string | null;
    success: boolean;
  }>;
  taskTheme: {
    name: string;
  };
}

export default function CustomCard({
  children,
  onClick,
  item,
  margin,
  taskId,
  userId
}: Props): ReactElement {
  const classes = useStyles({ margin } as Props)
  const [expertQuestion, setExpertQuestion] = useState<ExpertQuestionData | null>(null);
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    onClick && onClick(item)
  }

  


  useEffect(() => {
    if (taskId && userId) {
      handleGetQuestionExpert();
    }
  }, [taskId, userId])

  const handleGetQuestionExpert = async () => {
    try {
      const response = await getQuestion({
        task_id: taskId,
        user_id: userId
      })
      
      if (response.data && response.data.data) {
        const data = response.data.data;
        
        if (data.questions && Array.isArray(data.questions)) {
          const hasSuccessfulQuestions = data.questions.some(q => q.success === true);
          
          if (hasSuccessfulQuestions) {
            setExpertQuestion(data);
          } else {
            setExpertQuestion(null);
          }
        }
      }
    } catch (err) {
      console.log('при выполнении getQuestionExpert', err);
    }
  }

  const handleSetActiveQuestion = async () => {
    try {
      const successfulQuestions = expertQuestion?.questions.filter(q => q.success === true) || [];
      
      const promises = successfulQuestions.map(question => 
        setActiveQuestion({
          id: question.id,
          user_id: userId
        })
      );
      
      await Promise.all(promises);
      
    } catch (err) {
      console.log('при выполнении setActiveQuestion', err);
    }
  }

  const handleBellClick = async (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowModal(true);
    
    await handleSetActiveQuestion();
  }

  const handleCloseModal = async () => {
    setShowModal(false);
    await handleGetQuestionExpert();
  }


  return (
    <>
      <div className={classes.root} onClick={handleClick}>
        {/* Колокольчик в правом верхнем углу */}
        {expertQuestion && (
          <IconButton 
            className={classes.bellIcon}
            onClick={handleBellClick}
            size="small"
          >
            <Badge color="secondary" variant="dot">
              <Notifications className={classes.bellButton} />
            </Badge>
          </IconButton>
        )}
        
        <div className={classes.contentWrapper}>
          {children}
        </div>
      </div>

      {/* Модальное окно с вопросом и ответом эксперта */}
      {expertQuestion && (
        <ExpertQuestionModal
          open={showModal}
          onClose={handleCloseModal}
          questions={expertQuestion.questions
            .filter(q => q.success === true)
            .map(q => q.question)
          }
          answers={expertQuestion.questions
            .filter(q => q.success === true)
            .map(q => q.answer || 'Ответ не найден')
          }
        />
      )}
    </>
  )
}
